import { LoaderTypeEnum } from 'libs/shared/utils/loader/src/lib/+state/loader.models'

export interface TutorialVideosEntity {
  uuid: string
  video_url: string
  target: string
  title: string
}

export const TUTORIAL_VIDEOS_LOADER = {
  deleteTutorialVideo: {
    id: 'deleteTutorialVideo',
    type: LoaderTypeEnum.Dialog,
  },
}
